// extracted by mini-css-extract-plugin
export default {"subtitle":"WizardComponent_subtitle__Rc5SD","buttons":"WizardComponent_buttons__-IWd-"};